import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HawkinsProvider} from '@hawkins/components';
import {BrowserRouter as Router} from 'react-router-dom';

// Hawkins tables support
import '@netflix-internal/reactdatagrid-enterprise/base.css';
import '@hawkins/table/lib/css/hawkins-light.css';
import '@hawkins/table/lib/css/hawkins-dark.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HawkinsProvider><Router basename='/mgmt'><App /></Router></HawkinsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
